import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-license-image-card',
  templateUrl: './license-image-card.component.html',
  styleUrls: ['./license-image-card.component.scss'],
  standalone: false
})
export class LicenseImageCardComponent {
  @Input() imageUrl: SafeUrl | null = null;
  @Input() imageType: 'front' | 'back' = 'front';
  @Input() isUploaded: boolean = false;
  @Input() disabled: boolean = false;

  @Output() onUpload = new EventEmitter<'front' | 'back'>();
  @Output() onReplace = new EventEmitter<'front' | 'back'>();
  @Output() onView = new EventEmitter<'front' | 'back'>();

  get displayLabel(): string {
    return this.imageType === 'front' ? 'Front License' : 'Back License';
  }

  onCardClick(event: Event): void {
    if (this.disabled) {
      return;
    }

    if (this.isUploaded) {
      this.handleViewClick(event);
    } else {
      this.handleUploadClick();
    }
  }

  handleUploadClick(): void {
    if (!this.disabled) {
      this.onUpload.emit(this.imageType);
    }
  }

  handleReplaceClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.onReplace.emit(this.imageType);
    }
  }

  handleViewClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled && this.isUploaded) {
      this.onView.emit(this.imageType);
    }
  }
}

